module.exports = __webpack_public_path__ + "static/Trazado_1403-5acbd3441a1bb7c76ec016f8df57010c.svg";